import React from 'react';
import {
  Container, Row, Card, CardBody, Table
} from 'reactstrap';
import Slider from 'react-slide-out';
import FormComponent from "../form";
import 'react-slide-out/lib/index.css';
import TeamRoles from "./TeamRoles";
import TeamStatus from "./TeamStatus";
import client from "../../../../shared/api-client";
import Modal from "../../../../shared/modal";
import * as validate from "../../../../shared/validate";
import MoreActions from "./MoreActions/index"

class TeamCommon extends React.Component {
  state = {
    members: [],
    isOpen: false,
    isOpenSetPassword: false,
    roles: [],
    show: false,
    edit: [],
    formValues: {
      name: "",
      email: "",
      roles: [],
      meeting_link: "",
      bio: "",
      contact_number: "",
      timezone: "",
      organization_role: "",
    }
  };

  componentDidMount() {
    this.getRoles();
  }

  getRoles = () => {
    let roles = [];

    client(`admin_roles.php`).then(
      (response) => {

        response.data.forEach(role => {
          roles.push({'id': role.rid, 'name': role.role});
        });

        this.setState({roles}, () => {
          this.getUsers();
        });
      },
      (error) => {
        this.setState({show: true, errors: error._user_message});
      }
    );

    return roles;
  }

  getUsers = () => {
    client(`admin_team.php`).then(
      (members) => {
        this.setState({members});
      },
      (error) => {
        this.setState({show: true, errors: error._user_message});
      }
    );
  }

  toggleAddNewMembers = () => {
    this.setState({ isOpen: true, edit: [] });
  }

  editMember = (item) => {
    this.setState({ isOpen: true, edit: item });
  }

  setPassword = (item) => {
    this.setState({ isOpenSetPassword: true, edit: item });
  }

  updateRole = (member, roles) => {
    let userRoles = [];

    roles.forEach(role => {
      userRoles.push(role.id);
    })

    client(`admin_team.php`, {
      method: "POST",
      body: {aid: member.aid, roles: userRoles},
    }).then(
      (response) => {
        console.log(response);
      },
      (error) => {
        this.setState({show: true, errors: error._user_message});
      }
    );
  }

  updateStatus = (member, status) => {

    let members = this.state.members;
    
    members.map(data => {
      if (member.aid === data.aid) {
        data.status = status;
        client(`admin/team`, {
          method: "POST",
          body: {
            aid: member.aid,
            status: status
          },
        }).then(
          (response) => {
            this.setState({show: true, success: response._user_message});
          },
          (error) => {
            this.setState({show: true, errors: error._user_message});
          }
        );
      }

      return data;
    });

    this.setState({members});
  }

  handleForm = (formValues) => {
    this.setState({ formValues }, () => {
      // Validations will be added here if required frontend validations
    });
  };

  handleFormSetPassword = (formValues) => {
    this.setState({ formValues }, () => {
      // Validations will be added here if required frontend validations
    });
  };

  submitSetPassword = () => {
    
    let errors = []; 

    if (this.state.formValues.password === undefined 
      || !validate.required(this.state.formValues.password)) {
        errors.push('Please enter a valid password.')
    } else if (this.state.formValues.confirm_password === undefined 
      || !validate.required(this.state.formValues.confirm_password) 
      || this.state.formValues.confirm_password !== this.state.formValues.password) {
        errors.push('Confirm password does not matched.')
    }

    if (errors.length > 0) {
      this.setState({show: true, errors: errors, success: ''});
      return false;
    }

    client(`admin/profile`, {
      method: 'PUT',
      body: {
        aid: this.state.formValues.aid,
        password: this.state.formValues.password,
        confirm_password: this.state.formValues.confirm_password
      }
    }).then(
      (response) => {
        this.getUsers();
        this.setState({show: true, isOpenSetPassword: false, success: response._user_message, errors: [], prevState: false});
      },
      (error) => {
        this.setState({show: true, isOpenSetPassword: false, errors: error._user_message, success: ''});
      }
    );
  }

  submit = () => {

    let errors = [];    

    if (this.state.formValues.name === undefined 
      || !validate.required(this.state.formValues.name) 
      || !validate.name(this.state.formValues.name)) {
        errors.push('Please enter a valid name.')
    }

    let userRoles = [];

    if (!(this.state.formValues.aid !== undefined && this.state.formValues.aid > 0)) {
      if (this.state.formValues.email === undefined 
        || !validate.required(this.state.formValues.email) 
        || !validate.email(this.state.formValues.email)) {
          errors.push('Please enter a valid email address.')
      }      

      if (this.state.formValues !== undefined && this.state.formValues.roles !== undefined) {
        this.state.formValues.roles.forEach(role => {
          userRoles.push(role.id);
        });
      }
    }

    if (this.state.formValues.meeting_link !== undefined 
      && this.state.formValues.meeting_link.trim() !== '' 
      && !validate.url(this.state.formValues.meeting_link)) {
        errors.push('Please enter a valid meeting link.')
    }

    if (this.state.formValues.contact_number !== undefined 
      && this.state.formValues.contact_number.trim() !== '' 
      && !validate.number(this.state.formValues.contact_number)) {
        errors.push('Please enter a valid contact number.')
    }
    
    if (errors.length > 0) {
      this.setState({show: true, errors: errors, success: ''});
      return false;
    }

    let method = 'PUT';
    let body = [];

    if (this.state.formValues.aid !== undefined && this.state.formValues.aid > 0) {
      delete this.state.formValues.email;
      delete this.state.formValues.roles;

      method = 'POST';
      body = {
        aid: this.state.formValues.aid,
        name: this.state.formValues.name,
        meeting_link: this.state.formValues.meeting_link,
        bio: this.state.formValues.bio,
        contact_number: this.state.formValues.contact_number,
        timezone: this.state.formValues.timezone,
        organization_role: this.state.formValues.organization_role
      }
    } else {
      body = {
        name: this.state.formValues.name,
        email: this.state.formValues.email,
        roles: userRoles,
        meeting_link: this.state.formValues.meeting_link,
        bio: this.state.formValues.bio,
        contact_number: this.state.formValues.contact_number,
        timezone: this.state.formValues.timezone,
        organization_role: this.state.formValues.organization_role
      }
    }

    client(`admin/team`, {
      method: method,
      body: body
    }).then(
      (response) => {
        this.getUsers();
        this.setState({show: true, isOpen: false, success: response._user_message, errors: [], prevState: false});
      },
      (error) => {
        this.setState({show: true, isOpen: false, errors: error._user_message, success: ''});
      }
    );
  };

  deleteMember = (aid) => {
    client(`admin/team`, {
      method: "DELETE",
      body: {
        aid: aid
      }
    }).then(
      (response) => {
        this.getUsers();
        this.setState({show: true, success: response._user_message, errors: []});
      },
      (error) => {
        this.setState({show: true, errors: error._user_message, success: ''});
      }
    );
  }

  resendInvitation = (member) => {
    client(`admin/team`, {
      method: "POST",
      body: {
        aid: member.aid,
        email: member.email
      }
    }).then(
      (response) => {
        this.setState({show: true, success: response._user_message, errors: []});
      },
      (error) => {
        this.setState({show: true, errors: error._user_message, success: ''});
      }
    );
  }

  showModal = e => {
    this.setState({
      show: !this.state.show
    });
  };

  render() {
    return (
      <Container>
        <Row className="user-section">
          <Card className="table-section">
            <CardBody>
              <div className="card__title">
                <h5 className="bold-text">{this.props.title}</h5>
                <div className="toolbar-buttons">
                  <button type="button" onClick={() => {
                    this.setState({formValues: ''}, () => this.toggleAddNewMembers());
                  }} className="btn btn-sm btn-primary">Invite Team Member</button>
                </div>
              </div>
              <Table responsive hover className="table--head-accent table--bordered">
                <thead>
                  <tr>
                    {this.props.columnHeader.map(data => (<th key={data.key}>{data.name}</th>))}
                    {/* <th></th> */}
                  </tr>
                </thead>
                <tbody className="table--members">
                  {this.state.members.map(data => (
                    ('deleted' !== data.status ) ? 
                    <tr key={data.aid}>
                      <td>
                        <p>{data.name}</p>
                        <p>{data.email}</p>
                      </td>
                      <td>
                      
                      {('pending' !== data.status ) ? 
                        <TeamStatus member={data} key={() => 'status_' + data.aid} updateStatus={this.updateStatus} />  : 
                        <React.Fragment>
                          <button className="square btn btn-primary btn-sm" onClick={() =>  { return this.resendInvitation(data)}} type="button">Resend Invitation</button>
                          <button className="square btn btn-primary btn-sm" onClick={() =>  { return this.updateStatus(data, 'active')}} type="button">Mark Active</button>
                        </React.Fragment>
                         }
                      </td>
                      <td>
                        <TeamRoles roles={this.state.roles} key={() => 'roles_' + data.aid} member={data} updateRole={this.updateRole} />
                      </td>
                      <td>
                          <MoreActions 
                            onEditClicked={(item) => this.editMember(item) }  
                            onSetPasswordClicked={(item) => this.setPassword(item) } 
                            member={data} />
                      </td>
                    </tr> 
                    : ''
                  ))}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Row>
        <Slider
          isOpen={this.state.isOpen}
          footer={(
            <div className="button-container">
              <button className="square btn btn-primary btn-sm" onClick={() => this.submit()} type="button">Submit</button>
              <button type="button" className="square btn btn-danger btn-sm" onClick={() => this.setState({isOpen: false})}>
                Cancel
              </button>
            </div>
          )}
          onOutsideClick={() => this.setState({ isOpen: false })}
        >
          <FormComponent 
            title={this.state.edit.aid ? "Update Team Member" : "Add Team Member"} 
            toggleAddNewMembers={this.toggleAddNewMembers} 
            roles={this.state.roles} 
            handleForm={(formValues) => this.handleForm(formValues)} 
            edit={this.state.edit} 
            setPassword={false}
          />
        </Slider>
        <Slider
          isOpen={this.state.isOpenSetPassword}
          footer={(
            <div className="button-container">
              <button className="square btn btn-primary btn-sm" onClick={() => this.submitSetPassword()} type="button">Submit</button>
              <button type="button" className="square btn btn-danger btn-sm" onClick={() => this.setState({isOpenSetPassword: false})}>
                Cancel
              </button>
            </div>
          )}
          onOutsideClick={() => this.setState({ isOpenSetPassword: false })}
        >
          <FormComponent 
            title="Set Password" 
            toggleAddNewMembers={this.toggleAddNewMembers} 
            roles={this.state.roles} 
            handleForm={(formValues) => this.handleFormSetPassword(formValues)} 
            edit={this.state.edit} 
            setPassword={true}
          />
        </Slider>
        <Modal onClose={this.showModal} show={this.state.show} errors={this.state.errors} success={this.state.success} >
        </Modal>
      </Container>
    );
  }
}

export default TeamCommon;
